/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Msg_BotInputs */

const tr_landing_community_mock_msg_bot = /** @type {(inputs: Landing_Community_Mock_Msg_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet, panel 4 dilde: Türkçe, İngilizce, Almanca, Rusça.`)
};

const en_landing_community_mock_msg_bot = /** @type {(inputs: Landing_Community_Mock_Msg_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, the panel is available in 4 languages: Turkish, English, German and Russian.`)
};

const de_landing_community_mock_msg_bot = /** @type {(inputs: Landing_Community_Mock_Msg_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, das Panel gibt es in 4 Sprachen: Türkisch, Englisch, Deutsch und Russisch.`)
};

const ru_landing_community_mock_msg_bot = /** @type {(inputs: Landing_Community_Mock_Msg_BotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, панель доступна на 4 языках: турецкий, английский, немецкий и русский.`)
};

/**
* | output |
* | --- |
* | "Yes, the panel is available in 4 languages: Turkish, English, German and Russian." |
*
* @param {Landing_Community_Mock_Msg_BotInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_msg_bot = /** @type {((inputs?: Landing_Community_Mock_Msg_BotInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Msg_BotInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_msg_bot(inputs)
	if (locale === "de") return de_landing_community_mock_msg_bot(inputs)
	if (locale === "ru") return ru_landing_community_mock_msg_bot(inputs)
	return tr_landing_community_mock_msg_bot(inputs)
});